/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowFatLinesLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M114.34277,229.65674l-96-96a8.00182,8.00182,0,0,1,0-11.31348l96-96A8.0001,8.0001,0,0,1,128,32V72h24a8.00008,8.00008,0,0,1,8,8v96a8.00008,8.00008,0,0,1-8,8H128v40a8.0001,8.0001,0,0,1-13.65723,5.65674ZM216,184a8.00008,8.00008,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00008,8.00008,0,0,0,216,184Zm-32,0a8.00008,8.00008,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00008,8.00008,0,0,0,184,184Z" />
    </Svg>
  );
}

export default ArrowFatLinesLeft;
